import { TabTagType } from "#resources/helpers/tabs";
import classNames from "classnames";
import * as React from "react";
import s from "./menu-icon.scss";

export type MenuIconName =
	| "account-statement"
	| "audits"
	| "bag-icon"
	| "bar-report"
	| "bookings"
	| "business-inteligence"
	| "business-intelligence-v2"
	| "cash-flow"
	| "change-language"
	| "chart-of-accounts"
	| "chart-of-accounts-v2"
	| "clients"
	| "communication"
	| "contract"
	| "customers"
	| "delivery"
	| "delivery-person-white"
	| "employee"
	| "events"
	| "file-check"
	| "financial-report"
	| "financial"
	| "list-multiple"
	| "logout"
	| "loyalty"
	| "multivendor"
	| "multivendor-v2"
	| "new-storage"
	| "panel"
	| "password-card"
	| "pdv-status"
	| "pos-machine"
	| "products"
	| "promotions"
	| "report"
	| "reserve"
	| "satisfaction-survey"
	| "settings"
	| "stock-inventory"
	| "table-config"
	| "table-report"
	| "tax-data"
	| "tax"
	| "tickets-report"
	| "tickets"
	| "tickets-v2"
	| "bars"
	| "packages"
	| "whats-up"
	| "zig-account"
	| "zig-tag"
	| "crm"
	| "fiscal"
	| "place"
	| "team"
	| "reports"
	| "storage-reports"
	| "receptive"
	| "operation"
	| "pre-charge"
	| "config-adm"
	| "sell-with-no-card"
	| "devices"
	| "cargo-cart"
	| "giftback"
	| "users"
	| "recharge-management"
	| "kds"
	| "megaphone"
	| "dashboard-chart"
	| "table-map"
	| "help";

interface Props extends React.SVGProps<SVGElement> {
	icon: MenuIconName;
	className?: string;
	style?: React.CSSProperties;
	tagType?: TabTagType;
}

// Cache em nivel de modulo: React.lazy cria um "tipo" de componente novo a cada
// chamada. Chamando-o dentro do render, cada re-render da sidebar produzia um tipo
// diferente e o React desmontava e remontava o icone inteiro em vez de reconciliar
// -- o que aparecia como a sidebar "tremendo" ao trocar o item ativo.
const iconComponentCache = new Map<MenuIconName, React.ComponentType<any>>();

function getMenuIconComponent(icon: MenuIconName) {
	let Component = iconComponentCache.get(icon);
	if (!Component) {
		Component = React.lazy(() => import(`./icons/${icon}.svg`));
		iconComponentCache.set(icon, Component);
	}
	return Component;
}

export const MenuIcon = ({ className, icon, tagType, ...svgProps }: Props) => {
	const SvgComponent = getMenuIconComponent(icon);

	// O Suspense fica DENTRO da div para que o container (que reserva o espaco do
	// icone) sempre exista; envolvendo a div inteira, o fallback a substituia por um
	// texto solto, colapsando o layout a cada carregamento.
	return (
		<div className={classNames(s.icon, className)}>
			<React.Suspense fallback={null}>
				<SvgComponent data-icon={icon} {...svgProps} />
			</React.Suspense>

			{tagType && (
				<div
					className={classNames({
						[s.notification]: true,
						[s.new]: tagType === "new",
						[s.comingSoon]: tagType === "comingSoon",
					})}
				/>
			)}
		</div>
	);
};
